﻿import { Button, Play } from '@core/ui';
import { useTranslation } from 'react-i18next';

interface Props {
    onClick: () => void;
}

export const WebinarButtonResume = ({ onClick }: Props) => {
    const { t } = useTranslation();

    return (
        <Button type="button" variant="success" onClick={onClick}>
            <Play classNames="h-4 fill-current" />
            <span className="sr-only bc:not-sr-only bc:ml-3">{t('Broadcaster.Button.Resume')}</span>
        </Button>
    );
};
